import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { toAbsoluteUrl } from 'tradera-utils/url';
import { useTranslator } from 'tradera-lang/translate';

const BODY_PAGETYPE_CLASS_PREFIX = 'site-pagename-';

const PageHead = props => {
    const { t } = useTranslator();
    const {
        breadcrumbs,
        canonicalLink,
        metaDescription,
        metaRobots,
        metaTitle,
        metaTitleKey,
        metaTitleData,
        siteLayout,
        type
    } = props;

    const bodyClass = `${BODY_PAGETYPE_CLASS_PREFIX + type} ${
        siteLayout === 'site-width-full' ? 'site-width-full' : ''
    }`;
    const title =
        metaTitleKey && metaTitleData
            ? t(metaTitleKey, metaTitleData)
            : metaTitle;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={metaDescription} />
            <meta name="robots" content={metaRobots} />
            <link rel="canonical" href={toAbsoluteUrl(canonicalLink)} />
            <script type="application/ld+json">{breadcrumbs}</script>
            <body className={bodyClass} />
        </Helmet>
    );
};

const mapStateToProps = state => {
    return {
        breadcrumbs: state.page.breadcrumbs,
        canonicalLink: state.page.canonicalLink,
        metaDescription: state.page.metaDescription,
        metaRobots: state.page.metaRobots,
        metaTitle: state.page.metaTitle,
        metaTitleKey: state.page.metaTitleKey,
        metaTitleData: state.page.metaTitleData,
        type: state.page.type,
        siteLayout: state.ui.siteLayout
    };
};

export default connect(mapStateToProps)(PageHead);
